/*
 * Oak & Ember 3D — theme JavaScript
 * Header/drawers, AJAX cart (drawer + page), product forms & variant picker,
 * quick add, scroll reveal and product-card tilt. No dependencies.
 */
(function () {
  'use strict';
  var T = window.oakTheme || { routes: {}, strings: {}, animations: {} };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  /* ---------- helpers ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var formatString = format || T.moneyFormat || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision; thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var value = '';
    var m = formatString.match(placeholderRegex);
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  var toastTimer;
  function toast(message, ok) {
    var el = $('[data-toast]');
    if (!el) return;
    el.innerHTML = (ok !== false ? '<svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5 9-10"/></svg>' : '') + '<span></span>';
    el.querySelector('span').textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2800);
  }

  function lockScroll(lock) { document.documentElement.classList.toggle('oak-scroll-lock', !!lock); document.documentElement.style.overflow = lock ? 'hidden' : ''; }

  /* ---------- drawers (menu, cart) ---------- */
  var openDrawer = null;
  function drawerOpen(id, trigger) {
    var d = document.getElementById(id);
    if (!d) return;
    if (openDrawer && openDrawer !== d) drawerClose();
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    openDrawer = d; d._trigger = trigger || document.activeElement;
    lockScroll(true);
    var focusable = d.querySelector('[data-drawer-close], a, button, input');
    if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 60);
  }
  function drawerClose() {
    if (!openDrawer) return;
    var d = openDrawer;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    lockScroll(false);
    if (d._trigger && d._trigger.focus) d._trigger.focus({ preventScroll: true });
    openDrawer = null;
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); drawerOpen(opener.getAttribute('data-drawer-open'), opener); return; }
    if (e.target.closest('[data-drawer-close]') || (openDrawer && e.target.classList.contains('drawer__backdrop'))) { e.preventDefault(); drawerClose(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { drawerClose(); closeSearch(); $$('.site-nav details[open]').forEach(function (d) { d.open = false; }); }
  });

  /* ---------- header ---------- */
  function initHeader() {
    var header = $('[data-site-header]');
    if (header) {
      var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 8); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    // close desktop dropdowns when clicking outside
    document.addEventListener('click', function (e) {
      $$('.site-nav details[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
    });
  }
  function openSearch() {
    var s = $('[data-search-overlay]');
    if (!s) return;
    s.classList.add('is-open'); s.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    var input = s.querySelector('input[type="search"]');
    if (input) setTimeout(function () { input.focus(); }, 80);
  }
  function closeSearch() {
    var s = $('[data-search-overlay]');
    if (!s || !s.classList.contains('is-open')) return;
    s.classList.remove('is-open'); s.setAttribute('aria-hidden', 'true');
    lockScroll(false);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    else if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
    else if (e.target.hasAttribute && e.target.hasAttribute('data-search-overlay')) closeSearch();
  });

  /* ---------- cart ---------- */
  var Cart = {
    sectionsToRender: function () {
      var ids = ['cart-icon-bubble'];
      if (T.cartType === 'drawer') ids.push('cart-drawer');
      var main = $('[data-cart-section-id]');
      if (main) ids.push(main.getAttribute('data-cart-section-id'));
      return ids;
    },
    add: function (formData) {
      formData.append('sections', Cart.sectionsToRender().join(','));
      formData.append('sections_url', window.location.pathname);
      return fetch((T.routes.cart_add_url || '/cart/add') + '.js', { method: 'POST', body: formData, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || T.strings.cartError); return j; }); })
        .then(function (json) { Cart.render(json.sections); Cart.bumpCount(); return json; });
    },
    change: function (payload) {
      payload.sections = Cart.sectionsToRender().join(',');
      payload.sections_url = window.location.pathname;
      return fetch((T.routes.cart_change_url || '/cart/change') + '.js', { method: 'POST', body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json', Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || T.strings.cartError); return j; }); })
        .then(function (json) { Cart.render(json.sections); return json; });
    },
    updateNote: function (note) {
      return fetch((T.routes.cart_update_url || '/cart/update') + '.js', { method: 'POST', body: JSON.stringify({ note: note }), headers: { 'Content-Type': 'application/json', Accept: 'application/json' } });
    },
    render: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var target = document.getElementById('shopify-section-' + id);
        if (!target) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-' + id) || doc.body;
        target.innerHTML = fresh.innerHTML;
        initReveal(target);
      });
    },
    bumpCount: function () {
      $$('[data-cart-count]').forEach(function (c) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); });
    },
    afterAdd: function () {
      if (T.cartType === 'drawer' && document.getElementById('CartDrawer')) drawerOpen('CartDrawer');
      else toast(T.strings.added || 'Added to cart');
    }
  };

  // quantity +/- and line changes (delegated so re-rendered sections keep working)
  document.addEventListener('click', function (e) {
    var qBtn = e.target.closest('[data-qty-change]');
    if (qBtn) {
      var input = qBtn.parentNode.querySelector('input');
      if (!input) return;
      var step = parseInt(qBtn.getAttribute('data-qty-change'), 10) || 1;
      var min = parseInt(input.min || '0', 10);
      var val = Math.max(min, (parseInt(input.value, 10) || 0) + step);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      var item = rm.closest('[data-cart-item]');
      if (item) item.classList.add('is-updating');
      Cart.change({ line: parseInt(rm.getAttribute('data-cart-remove'), 10), quantity: 0 }).catch(function (err) { toast(err.message, false); if (item) item.classList.remove('is-updating'); });
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-line-qty]');
    if (input) {
      var item = input.closest('[data-cart-item]');
      if (item) item.classList.add('is-updating');
      Cart.change({ line: parseInt(input.getAttribute('data-cart-line-qty'), 10), quantity: parseInt(input.value, 10) || 0 }).catch(function (err) { toast(err.message, false); if (item) item.classList.remove('is-updating'); });
      return;
    }
    var note = e.target.closest('[data-cart-note]');
    if (note) Cart.updateNote(note.value);
  });

  /* ---------- product form + variant picker ---------- */
  function initProductForms(root) {
    $$('[data-product-form]', root).forEach(function (wrap) {
      if (wrap._init) return; wrap._init = true;
      var form = wrap.querySelector('form[action*="/cart/add"]');
      var jsonEl = wrap.querySelector('[data-product-json]');
      var product = null;
      try { product = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (err) { product = null; }
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var priceEl = wrap.querySelector('[data-product-price]');
      var btn = form ? form.querySelector('[data-add-to-cart]') : null;
      var btnLabel = btn ? btn.querySelector('.btn__label') : null;
      var stockEl = wrap.querySelector('[data-product-stock]');
      var skuEl = wrap.querySelector('[data-product-sku]');
      var picker = wrap.querySelector('[data-variant-picker]');

      function selectedOptions() {
        var opts = [];
        $$('[data-option-index]', picker).forEach(function (group) {
          var checked = group.querySelector('input:checked');
          var select = group.querySelector('select');
          opts.push(checked ? checked.value : (select ? select.value : null));
        });
        return opts;
      }
      function findVariant(opts) {
        if (!product) return null;
        return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }) || null;
      }
      function updateAvailability(opts) {
        $$('[data-option-index]', picker).forEach(function (group, gi) {
          $$('input', group).forEach(function (input) {
            var test = opts.slice(); test[gi] = input.value;
            var exists = product.variants.some(function (v) { return v.options.every(function (o, i) { return i === gi ? o === input.value : o === test[i]; }) && v.available; });
            input.classList.toggle('is-unavailable', !exists);
          });
        });
      }
      function render(variant) {
        if (btn) {
          if (!variant) { btn.disabled = true; if (btnLabel) btnLabel.textContent = T.strings.unavailable; }
          else if (!variant.available) { btn.disabled = true; if (btnLabel) btnLabel.textContent = T.strings.soldOut; }
          else { btn.disabled = false; if (btnLabel) btnLabel.textContent = btn.getAttribute('data-label-default') || T.strings.addToCart; }
        }
        if (variant && idInput) idInput.value = variant.id;
        if (variant && priceEl) {
          var html = '';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html = '<span class="price__sale">' + formatMoney(variant.price) + '</span><s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
          } else html = '<span class="price__regular">' + formatMoney(variant.price) + '</span>';
          priceEl.innerHTML = html;
          priceEl.classList.remove('is-bump'); void priceEl.offsetWidth; priceEl.classList.add('is-bump');
          var mirror = wrap.querySelector('[data-product-price-mirror]');
          if (mirror) mirror.innerHTML = html;
        }
        var stickyBtn = wrap.querySelector('[data-sticky-atc-btn]');
        if (stickyBtn && btn) {
          stickyBtn.disabled = btn.disabled;
          var stickyLabel = stickyBtn.querySelector('.btn__label');
          if (stickyLabel && btnLabel) stickyLabel.textContent = btnLabel.textContent;
        }
        if (skuEl) { skuEl.textContent = variant && variant.sku ? variant.sku : ''; skuEl.parentNode.hidden = !(variant && variant.sku); }
        if (stockEl && variant) {
          stockEl.classList.remove('product__stock--low', 'product__stock--out');
          if (!variant.available) { stockEl.textContent = stockEl.getAttribute('data-out'); stockEl.classList.add('product__stock--out'); }
          else if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) { stockEl.textContent = stockEl.getAttribute('data-low').replace('__COUNT__', variant.inventory_quantity); stockEl.classList.add('product__stock--low'); }
          else stockEl.textContent = stockEl.getAttribute('data-in');
        }
        if (variant && variant.featured_media) activateMedia(wrap, variant.featured_media.id);
        if (variant && window.history.replaceState && wrap.hasAttribute('data-update-url')) {
          var url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url.toString());
        }
        $$('[data-option-index]', picker).forEach(function (group, gi) {
          var label = group.querySelector('[data-option-value]');
          var opts = selectedOptions();
          if (label) label.textContent = opts[gi] || '';
        });
      }
      if (picker && product) {
        picker.addEventListener('change', function () {
          var opts = selectedOptions();
          updateAvailability(opts);
          render(findVariant(opts));
        });
        updateAvailability(selectedOptions());
      }
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (btn && btn.disabled) return;
          var fd = new FormData(form);
          if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
          Cart.add(fd).then(function () {
            Cart.afterAdd();
            // soft success state on the button
            if (btn && btnLabel) {
              var previous = btnLabel.textContent;
              btn.classList.add('is-added'); btnLabel.textContent = T.strings.added || previous;
              setTimeout(function () { btn.classList.remove('is-added'); btnLabel.textContent = previous; }, 1600);
            }
          }).catch(function (err) { toast(err.message || T.strings.cartError, false); })
            .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
        });
      }
      // gallery thumbnails
      $$('[data-media-thumb]', wrap).forEach(function (thumb) {
        thumb.addEventListener('click', function () { activateMedia(wrap, thumb.getAttribute('data-media-thumb')); });
      });
      // keyboard arrows on the stage
      var stage = wrap.querySelector('[data-media-stage]');
      if (stage) {
        stage.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var thumbs = $$('[data-media-thumb]', wrap);
          var idx = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
          var next = thumbs[(idx + (e.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length];
          if (next) next.click();
        });
      }
    });
  }
  function activateMedia(wrap, id) {
    id = String(id);
    $$('[data-media-id]', wrap).forEach(function (m) { m.classList.toggle('is-active', m.getAttribute('data-media-id') === id); });
    $$('[data-media-thumb]', wrap).forEach(function (t) { var on = t.getAttribute('data-media-thumb') === id; t.classList.toggle('is-active', on); if (on && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion ? 'auto' : 'smooth' }); });
  }

  /* ---------- quick add (single-variant products) ---------- */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    var variantId = qa.getAttribute('data-quick-add');
    if (!variantId) { window.location.href = qa.getAttribute('data-url'); return; }
    var fd = new FormData(); fd.append('id', variantId); fd.append('quantity', '1');
    qa.classList.add('is-loading');
    Cart.add(fd).then(function () { Cart.afterAdd(); }).catch(function (err) { toast(err.message || T.strings.cartError, false); }).finally(function () { qa.classList.remove('is-loading'); });
  });

  /* ---------- scroll reveal ---------- */
  var revealIo = null;
  function initReveal(root) {
    var targets = $$('[data-reveal], [data-reveal-stagger]', root || document);
    if (!T.animations.reveal || reduceMotion || !('IntersectionObserver' in window)) { targets.forEach(function (t) { t.classList.add('is-inview', 'is-revealed'); }); return; }
    if (!revealIo) revealIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var target = en.target;
        target.classList.add('is-inview');
        revealIo.unobserve(target);
        // once the stagger has played, release the children so their own hover transitions take over
        if (target.hasAttribute('data-reveal-stagger')) setTimeout(function () { target.classList.add('is-revealed'); }, 1300);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (t) { if (!t.classList.contains('is-inview')) revealIo.observe(t); });
  }

  /* ---------- 3D tilt on product cards ---------- */
  function initTilt(root) {
    if (!T.animations.tilt || reduceMotion || !finePointer) return;
    $$('.product-card', root || document).forEach(function (card) {
      if (card._tilt) return; card._tilt = true;
      var raf = null, rx = 0, ry = 0;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        ry = ((e.clientX - r.left) / r.width - 0.5) * 8;
        rx = (0.5 - (e.clientY - r.top) / r.height) * 8;
        if (!raf) raf = requestAnimationFrame(function () { raf = null; card.style.transform = 'perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) translateY(-4px)'; });
      });
      card.addEventListener('pointerleave', function () { card.style.transform = ''; });
    });
  }

  /* ---------- collection sort ---------- */
  document.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-sort-by]');
    if (!sort) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value); url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- product recommendations (Shopify recommendations API) ---------- */
  function initRecommendations(root) {
    $$('[data-recommendations-url]', root || document).forEach(function (el) {
      if (el._loaded) return; el._loaded = true;
      fetch(el.getAttribute('data-recommendations-url')).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initReveal(el); initTilt(el); }
      }).catch(function () { /* silent */ });
    });
  }

  /* ---------- page transitions ---------- */
  // Browsers with cross-document View Transitions animate page changes from CSS. Others get a CSS page-enter:
  // the ".no-vt" class is set by an inline script in the <head> (layout/theme.liquid) so it applies before first paint.
  // Shared-element transition: the clicked product card image morphs into the product page's main image.
  function clearTransitionNames() {
    $$('.product-card__media img').forEach(function (i) { i.style.viewTransitionName = ''; });
    $$('.product__media img').forEach(function (i) { i.style.viewTransitionName = ''; });
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[href]') : null;
    var card = link ? link.closest('.product-card') : null;
    if (!card) return;
    var img = card.querySelector('.product-card__media img');
    if (!img) return;
    clearTransitionNames();
    // only one element per page may carry the name, so the current product image gives it up first
    $$('.product__media img').forEach(function (i) { i.style.viewTransitionName = 'none'; });
    img.style.viewTransitionName = 'oak-product-media';
  }, true);
  window.addEventListener('pageshow', clearTransitionNames);

  /* ---------- animated titles: words rise in one after another ---------- */
  function initSplitTitles(root) {
    $$('[data-split-title]', root).forEach(function (el) {
      if (el._split) return; el._split = true;
      if (reduceMotion) return;
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;
      el.setAttribute('aria-label', text);
      el.textContent = '';
      text.split(' ').forEach(function (word, i) {
        var outer = document.createElement('span'); outer.className = 'word'; outer.setAttribute('aria-hidden', 'true'); outer.style.setProperty('--w', i);
        var inner = document.createElement('span'); inner.textContent = word;
        outer.appendChild(inner); el.appendChild(outer); el.appendChild(document.createTextNode(' '));
      });
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-split-in'); }); });
    });
  }

  /* ---------- count-up numbers ---------- */
  function initCountUp(root) {
    $$('[data-count-up]', root).forEach(function (el) {
      if (el._counted) return; el._counted = true;
      var target = parseInt(el.getAttribute('data-count-up'), 10);
      if (!target || reduceMotion) return;
      var start = null, duration = 1100;
      el.textContent = '0';
      var step = function (t) {
        if (start === null) start = t;
        var p = Math.min(1, (t - start) / duration);
        el.textContent = String(Math.round(target * (1 - Math.pow(1 - p, 3))));
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
  }

  /* ---------- category chips: keep the active chip in view ---------- */
  function initChips(root) {
    $$('[data-cat-chips]', root).forEach(function (strip) {
      var active = strip.querySelector('.is-active');
      if (active) strip.scrollLeft = Math.max(0, active.offsetLeft - strip.clientWidth / 2 + active.clientWidth / 2);
    });
  }

  /* ---------- soft pointer spotlight on category cards + parallax ---------- */
  if (finePointer) {
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest ? e.target.closest('.cat-card') : null;
      if (!card) return;
      var r = card.getBoundingClientRect();
      card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      card.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }
  var parallaxEls = [], parallaxQueued = false;
  function updateParallax() {
    parallaxQueued = false;
    parallaxEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var img = el.firstElementChild;
      if (img) img.style.transform = 'translateY(' + Math.round(-r.top / 10) + 'px)';
    });
  }
  function initParallax(root) {
    if (reduceMotion) return;
    $$('[data-parallax]', root).forEach(function (el) { if (parallaxEls.indexOf(el) === -1) parallaxEls.push(el); });
    if (parallaxEls.length && !initParallax.bound) {
      initParallax.bound = true;
      window.addEventListener('scroll', function () { if (!parallaxQueued) { parallaxQueued = true; requestAnimationFrame(updateParallax); } }, { passive: true });
    }
    updateParallax();
  }

  /* ---------- smooth accordions ---------- */
  function initAccordions(root) {
    $$('.accordion details', root).forEach(function (d) {
      if (d._acc) return; d._acc = true;
      var summary = d.querySelector('summary'), body = d.querySelector('.accordion__body');
      if (!summary || !body || reduceMotion || !body.animate) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (d._anim) d._anim.cancel();
        // the body has bottom padding, so it is animated together with the height (otherwise it bottoms out at 18px and snaps)
        if (d.open) {
          var h = body.offsetHeight, pad = getComputedStyle(body).paddingBottom;
          d._anim = body.animate([{ height: h + 'px', paddingBottom: pad, opacity: 1 }, { height: '0px', paddingBottom: '0px', opacity: 0 }], { duration: 280, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' });
          d._anim.onfinish = function () { d.open = false; d._anim = null; };
        } else {
          d.open = true;
          var h2 = body.offsetHeight, pad2 = getComputedStyle(body).paddingBottom;
          d._anim = body.animate([{ height: '0px', paddingBottom: '0px', opacity: 0 }, { height: h2 + 'px', paddingBottom: pad2, opacity: 1 }], { duration: 360, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
          d._anim.onfinish = function () { d._anim = null; };
        }
      });
    });
  }

  /* ---------- sticky add to cart ---------- */
  function initStickyAtc(root) {
    $$('[data-sticky-atc]', root).forEach(function (bar) {
      if (bar._init) return; bar._init = true;
      var wrap = bar.closest('[data-product-form]');
      var mainBtn = wrap ? wrap.querySelector('[data-add-to-cart]') : null;
      var form = wrap ? wrap.querySelector('form[action*="/cart/add"]') : null;
      if (!mainBtn || !form || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(mainBtn);
      var b = bar.querySelector('[data-sticky-atc-btn]');
      if (b) b.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else mainBtn.click(); });
    });
  }

  /* ---------- init ---------- */
  function init(root) {
    initProductForms(root);
    initReveal(root);
    initTilt(root);
    initRecommendations(root);
    initSplitTitles(root);
    initCountUp(root);
    initChips(root);
    initParallax(root);
    initAccordions(root);
    initStickyAtc(root);
  }
  document.addEventListener('DOMContentLoaded', function () { initHeader(); init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var room = e.target.closest ? e.target.closest('oak-room-3d') : null;
    if (room && room.items) {
      var match = e.target.getAttribute('data-hotspot-match');
      var item = room.items.find(function (it) { return it.hotspot && it.hotspot.match === match; });
      if (item) room.select(item);
    }
  });

  // leaving a hotspot block in the editor lets its piece settle again (otherwise it would keep floating)
  document.addEventListener('shopify:block:deselect', function (e) {
    var room = e.target.closest ? e.target.closest('oak-room-3d') : null;
    if (room && room.ready && room.select) room.select(null);
  });

  window.oakTheme.cart = Cart;
  window.oakTheme.toast = toast;
  window.oakTheme.formatMoney = formatMoney;
  window.oakTheme.openDrawer = drawerOpen;
  window.oakTheme.closeDrawer = drawerClose;
})();
